export const time = {
  second: {
    middle: 'det.',
    short: 'd.'
  }
};
